import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => {
  const t = localStorage.getItem("archive_member_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};
const c = () => axios.create({ baseURL: API, headers: auth() });

export const getWorkbench = () => c().get("/members/me/workbench").then((r) => r.data);
export const saveDesk = (modules, locked) => c().put("/members/me/workbench/desk", { modules, locked }).then((r) => r.data);
export const resetDesk = () => c().post("/members/me/workbench/desk/reset").then((r) => r.data);
export const setInvestigation = (slug) => c().put("/members/me/workbench/investigation", { slug }).then((r) => r.data);
export const getWall = () => c().get("/members/me/wall").then((r) => r.data);
export const createPin = (type, ref, note) => c().post("/members/me/wall/pins", { type, ref, note }).then((r) => r.data);
export const patchPin = (id, body) => c().patch(`/members/me/wall/pins/${id}`, body).then((r) => r.data);
export const saveWallLayout = (positions) => c().put("/members/me/wall/layout", { positions }).then((r) => r.data);
export const deletePin = (id) => c().delete(`/members/me/wall/pins/${id}`).then((r) => r.data);
export const checkPinned = (type, ref) => c().get("/members/me/wall/pinned", { params: { type, ref } }).then((r) => r.data);
export const createConnection = (a, b, label) => c().post("/members/me/wall/connections", { a, b, label }).then((r) => r.data);
export const deleteConnection = (id) => c().delete(`/members/me/wall/connections/${id}`).then((r) => r.data);
export const listNotes = () => c().get("/members/me/notes").then((r) => r.data);
export const createNote = (body) => c().post("/members/me/notes", { body }).then((r) => r.data);
export const updateNote = (id, body) => c().patch(`/members/me/notes/${id}`, { body }).then((r) => r.data);
export const deleteNote = (id) => c().delete(`/members/me/notes/${id}`).then((r) => r.data);
